import { IconPropsType } from '../IconProps.type';
import { ICON_TYPES } from '../constants';

export const DownArrowIcon = (props: IconPropsType): JSX.Element => {
  const { fill = '#43494F' } = props;

  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.880768 4.04613C0.995675 4.04598 1.10947 4.06858 1.2156 4.11263C1.32173 4.15668 1.41808 4.22132 1.4991 4.3028L5.97502 8.77813C6.11044 8.91359 6.27122 9.02105 6.44818 9.09436C6.62514 9.16767 6.81481 9.2054 7.00635 9.2054C7.19789 9.2054 7.38756 9.16767 7.56452 9.09436C7.74148 9.02105 7.90226 8.91359 8.03768 8.77813L12.5066 4.30863C12.5873 4.22506 12.6839 4.1584 12.7906 4.11254C12.8974 4.06668 13.0122 4.04255 13.1284 4.04154C13.2446 4.04053 13.3598 4.06267 13.4673 4.10666C13.5748 4.15066 13.6725 4.21563 13.7547 4.29779C13.8369 4.37994 13.9018 4.47764 13.9458 4.58517C13.9898 4.69271 14.012 4.80793 14.0109 4.92411C14.0099 5.04029 13.9858 5.15511 13.9399 5.26186C13.8941 5.36861 13.8274 5.46516 13.7439 5.54588L9.27493 10.0154C8.67288 10.6163 7.85699 10.9538 7.00635 10.9538C6.15571 10.9538 5.33982 10.6163 4.73777 10.0154L0.261851 5.54005C0.1394 5.41768 0.056001 5.26173 0.0222061 5.09194C-0.0115888 4.92216 0.00573975 4.74616 0.0719991 4.58623C0.138258 4.4263 0.250471 4.28961 0.394437 4.19347C0.538402 4.09733 0.707652 4.04605 0.880768 4.04613Z"
        fill={fill}
      />
    </svg>
  );
};

DownArrowIcon.iconType = ICON_TYPES.DOWNARROW;
